import "./Team.scss";
import Modal from "../../components/Modal/Modal";
import { HiChevronDoubleDown } from "react-icons/hi";
import { useGlobalContext } from "../../contexts/context";
import { teamMembers } from "../../data/data";
import { Link as Scroll } from "react-scroll";
import Banner from "../../components/Banner";

const TeamPage = () => {
  const {
    modalOpen,
    selectedTeamMember,
    handleTeamMemberClick,
    handleModalClose,
  } = useGlobalContext();
  return (
    <>
      <section className="header-bg section">
        <div className="banner">
          <Banner />
        </div>
        <article className="header-bg__container">
          <div className="header-bg__container-contents">
            <h1 className="">ORGANIZERS</h1>
          </div>

          <Scroll
            to="next-section"
            smooth={true}
            duration={100}
            delay={0}
            offset={100}
            style={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="scroll-btn">
              <HiChevronDoubleDown />
              <span>Scroll Down</span>
            </div>
          </Scroll>
        </article>
      </section>

      <section className="section team" id="next-section">
        <article className="team__container container">
          <p className="team__container--desc">
            A large group of volunteers dedicate their time and energy to set up
            events and build our community, acting as personal ambassadors for
            change and innovation. With their professional skills and knowledge,
            our volunteers bring ideas to life from behind the scenes to the day
            of the events. We are a hundred percent volunteer-led organisation
            and are run solely on the enthusiasm of our partners, collaborators
            and volunteers. Together we bring ideas to life that go beyond
            limitation and pushes boundaries to create a better city, a better
            world. These are not all of them but are some of the key people that
            are making TEDxOAU a reality.
          </p>

          <div className="team__container-contents">
            {teamMembers.map((teamMember) => {
              const { name, role, image } = teamMember;
              return (
                <div
                  key={name}
                  className="team__contents-body"
                  data-aos="fade-down"
                  onClick={() => handleTeamMemberClick(teamMember)}
                >
                  <div className="team__body-menu"></div>
                  <div>
                    <span className="team__list">
                      <span className="team__item">
                        <img src={image} alt={name} />
                      </span>
                    </span>
                  </div>

                  <div className="team__bio">
                    <h3>{name}</h3>
                    <p>{role}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </article>
      </section>

      <Modal
        selectedTeamMember={selectedTeamMember}
        handleClose={handleModalClose}
        modalOpen={modalOpen}
      />
    </>
  );
};

export default TeamPage;
